export default {
  name: 'html-textarea',
  components: {},
  props: ['value'],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted: function () {
    this.$el.innerHTML = this.value;
  },
  methods: {
    updateHTML: function(e) {
      this.$emit('input', e.target.innerHTML);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/html-textarea/html-textarea.js